import { styled } from "@mui/material/styles";

const ErrorRoot = styled("div")(({ theme }) => ({
  fontSize: "12px",
  position: "relative",
  "& p": {
    lineHeight: "1",
    margin: "0",
    color: theme.palette.error.main
  },
  "& svg": {
    marginRight: "5px"
  }
}));

const ErrorContainer = styled("div")(({ theme }) => ({
  marginTop: "10px",
  display: "flex",
  alignItems: "center"
}));

export { ErrorRoot, ErrorContainer };
